import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Navigation />
      <div className="content">
        <h1>Neo-Assyrian Bas-Reliefs Digital Archive</h1>
        
        <section className="welcome-section">
          <h2>Welcome to the Bas Relief Atlas</h2>
          <p>
            This digital archive documents the magnificent bas-reliefs from King Ashurnasirpal II's palace, 
            making these historical treasures accessible to scholars, students, and enthusiasts worldwide.
          </p>
        </section>

        <section className="featured-section">
          <h2>Featured Reliefs</h2>
          <p>Coming soon: A curated selection of significant bas-reliefs from our collection.</p>
        </section>

        <section className="quick-links">
          <h2>Quick Links</h2>
          <ul>
            <li><Link to="/catalog">Browse the complete catalog</Link></li>
            <li><Link to="/map">View the interactive map</Link></li>
            <li><Link to="/contribute">Contribute to the archive</Link></li>
            <li><Link to="/about">Learn about the project</Link></li>
          </ul>
        </section>
      </div>
      
      <footer>
        <p>2024 Bas Relief Atlas - A Digital Archive of Neo-Assyrian Bas-Reliefs</p>
      </footer>
    </div>
  );
};

export default HomePage; 